import styled from 'styled-components';
import { MapContainer } from 'react-leaflet';

export const FlexWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const StyledMapContainer = styled(MapContainer)`
    width: 100%;
    height: 300px;
    margin-bottom: ${({ theme }) => theme.spacing * 4}px;
`;
